export const HD_720_QUALITY = 720

export const VIDEO_API_PATH =
  window.VIDEO_API_PATH || '//video-api.local.renderforest.com/api/v1'

export const REC_API_PATH =
  window.RECOMMENDATION_API_PATH ||
  '//recommendation-api.local.renderforest.com/api/v1'

export const AI_IMAGE_API_PATH =
  window.AI_IMAGE_API_PATH || '//ai-image-api.local.renderforest.com/api/v1'

export const AI_VIDEO_API_PATH =
  window.AI_VIDEO_API_PATH || '//ai-video-api.local.renderforest.com/api/v1'

export const GENERATE_VIDEO_MOCKS = {
  aspectRatio: 'landscape',
  enhanceScript: true
}
